import axios from 'axios';
import { handleApiError } from './errorHandler';
import { getAuthHeader } from './auth';

// Create axios instance
const apiClient = axios.create();

// Request interceptor to add authorization header
apiClient.interceptors.request.use(
  (config) => {
    // Add authorization header if token exists
    const authHeader = getAuthHeader();
    if (authHeader.Authorization) {
      config.headers.Authorization = authHeader.Authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
apiClient.interceptors.response.use(
  (response) => {
    // Return response if successful
    return response;
  },
  (error) => {
    // Handle API errors with appropriate user feedback
    handleApiError(error);
    
    // Return the error to be handled by the calling code
    return Promise.reject(error);
  }
);

export default apiClient;